<script setup>
import {onMounted, ref, computed} from "vue";
import {useInboxStore} from "@/stores/inbox.js";
import {gregorianDate} from "@/utils/gregorianDate.js";
import Breadcrumbs from "@/components/Breadcrumbs/index.vue";
import {Icon} from "@iconify/vue";
import {showMessage} from "@/utils/showMessage.js";

const inboxStore = useInboxStore();
const loading = ref(false)
const inboxMessages = computed(() => inboxStore.getMessages)

const getAllInbox = async (showLoading = true) => {
  if (showLoading) loading.value = true
  const res = await inboxStore.action_getAllInbox();
  if (res.result === true) {
    await setDelivery();
  } else {
    showMessage(res, 'error');
  }
  loading.value = false
}

const setDelivery = async () => {
  if (inboxStore.getLastUnreadMessageID) {
    const res = await inboxStore.action_setDelivery();
    setTimeout(async () => {
      await getAllInbox(false);
    }, 3000)
  }
}

onMounted(() => {
  getAllInbox()
})
</script>

<template>
  <div class="h-full">
    <div class="flex flex-col gap-4 w-full h-full">
      <div class="flex flex-row justify-between gap-4 w-full">
        <Breadcrumbs/>
      </div>
      <div v-if="loading" class="flex items-center justify-center h-60">
        <Icon icon="eos-icons:bubble-loading" class="size-12"/>
      </div>
      <div v-else-if="inboxStore.getMessages.length > 0"
           class="h-full overflow-y-auto custom-scrollbar">
        <div v-for="message in inboxMessages"
             class="lg:hidden flex flex-col gap-4 px-4 py-4 text-white border-b border-slate-700 last:border-0">
          <div class="flex flex-col gap-2">
            <div class="flex flex-row justify-between gap-2 text-xs">
              <div class="text-slate-400">From: {{ message.senderName }}</div>
              <div class="text-blue-200">
                {{ gregorianDate(message.sendTime, 'DD MMM YYYY HH:mm') }}
              </div>
            </div>
            <div class="grid grid-cols-[auto,1fr] gap-x-2">
              <div class="col-start-1 col-end-2 flex items-center">
                <!--if no notification-->
                <div v-if="message.deliverTime" class="h-2 w-2"></div>
                <!--if has notification -->
                <div v-else class="h-2 w-2 rounded-full bg-red-500"></div>
              </div>
              <div class="col-start-2 col-end-3">
                {{ message.message }}
              </div>
              <!--              <div class="col-start-2 col-end-3">
                              <div class="text-sm text-slate-400">desc</div>
                            </div>-->
            </div>
          </div>
          <!--          <div class="flex flex-row justify-between items-center">
                      <button class="text-sm text-slate-300 bg-blue-900 px-4 py-1 border border-slate-500 rounded-md">
                        read more
                      </button>
                    </div>-->
        </div>
        <div v-for="message in inboxMessages"
             class="hidden lg:flex flex-row gap-4 px-4 py-4 text-white border-b border-slate-700 last:border-0">
          <div class="flex-1 flex flex-col gap-2">
            <div class="flex flex-row justify-between gap-2 text-xs">
              <div class="text-slate-400">From: {{ message.senderName }}</div>
              <div class="text-blue-200">{{ gregorianDate(message.sendTime, 'DD MMM YYYY HH:mm') }}</div>
            </div>
            <div class="grid grid-cols-[auto,1fr,auto] gap-x-2">
              <div class="col-start-1 col-end-2 flex items-center">
                <!--if no notification-->
                <div v-if="message.deliverTime" class="h-2 w-2"></div>
                <!--if has notification -->
                <div v-else class="h-2 w-2 rounded-full bg-red-500"></div>
              </div>
              <div class="col-start-2 col-end-3">
                {{ message.message }}
              </div>
              <!--              <div class="col-start-2 col-end-3">
                              <div class="text-sm text-slate-400">desc</div>
                            </div>-->
            </div>
          </div>
          <!--          <div class="flex flex-col justify-end">
                      <button class="text-sm text-slate-300 bg-blue-900 px-4 py-1 border border-slate-500 rounded-md">
                        read more
                      </button>
                    </div>-->
        </div>
      </div>
      <div v-else class="text-slate-400 text-sm h-40 flex items-center justify-center">
        No message has been sent to you yet.
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>